import Typography from '@liquidweb-dev/undercurrent/Typography';
import ChartColumnIcon from '@liquidweb-dev/undercurrent/icons/lucide/ChartColumn';
import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import VPSToolsUptime from 'images/advanced-vps-tools-uptime.png';
import DialogUTM from '../DialogUTM';

interface AdvancedVPSToolsUptimeProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}

const AdvancedVPSToolsUptime = (props: AdvancedVPSToolsUptimeProps) => {
	return (
		<DialogUTM
			title="Manage and protect your server"
			image={VPSToolsUptime}
			badge={{
				icon: ChartColumnIcon,
				label: 'Advanced Tools & Uptime',
			}}
			dialogContent={{
				title: 'Manage and protect your server',
				description: (
					<Stack
						sx={{
							gap: 400,
						}}
					>
						<Typography variant="body-md">
							<Stack
								sx={{
									gap: 300,
								}}
							>
								<Box>
									Reboot or resize your VPS directly from your
									server&apos;s&nbsp;
									<Typography
										sx={{
											fontWeight: 700,
										}}
									>
										{' '}
										three-dot menu
									</Typography>{' '}
									in the portal.
								</Box>
								<Box>
									For added security, go to the{' '}
									<Typography
										sx={{
											fontWeight: 700,
										}}
									>
										Settings tab
									</Typography>{' '}
									to add-on Advanced DDoS Protection and safeguard against
									spikes and attacks.
								</Box>
							</Stack>
						</Typography>
						<Button
							variant="secondary"
							size="medium"
							sx={{ paddingX: 150, paddingY: 100, alignSelf: 'flex-start' }}
							href="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/resize-a-cloud-server/"
							target="_blank"
						>
							Learn more about Resizing
						</Button>
					</Stack>
				),
			}}
			{...props}
		/>
	);
};

export default AdvancedVPSToolsUptime;
